import { render, staticRenderFns } from "./ConfigGeneral.vue?vue&type=template&id=5c75a06a&"
import script from "./ConfigGeneral.vue?vue&type=script&lang=js&"
export * from "./ConfigGeneral.vue?vue&type=script&lang=js&"
import style0 from "./ConfigGeneral.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports